import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { designTokens } from '../../../ui/foundation/DesignTokens';

export const FileCardContainer = styled.div`
  width: 100%;
  max-width: 400px;
  height: auto;
  overflow: hidden;
  position: relative;
  border-radius: ${designTokens.radius.lg};
  display: inline-block;
  cursor: pointer;
  transition: all 0.2s ease;

  ${(props) => props.isFacebookAd && !props.isClientSender &&
    css`
      background-color: #0202020b;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    `}

  ${(props) => props.isFacebookAd && props.isClientSender &&
    css`
      width: 100%;
      max-width: 100%;
    `}

  ${(props) => props.isChatSelector &&
    css`
      width: 100%;
      max-width: 100%;
      background: white;
      border: 1px solid ${designTokens.colors.gray[200]};
      box-shadow: ${designTokens.shadows.sm};

      &:hover {
        transform: translateY(-4px);
        box-shadow: ${designTokens.shadows.md};
        border-color: ${designTokens.colors.primary[200]};
      }

      &:active {
        transform: translateY(-2px);
      }
    `}
`;

export const FileImage = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: ${(props) => props.isChatSelector ? `${designTokens.radius.lg} ${designTokens.radius.lg} 0 0` : '10px'};

  ${(props) => props.isFacebookAd && !props.isClientSender &&
    css`
      width: 100px;
      height: 100px;
      object-fit: cover;
      object-position: center;
    `}

  ${(props) => props.isChatSelector &&
    css`
      height: 140px;
      object-fit: cover;
    `}
`;

export const FileDescriptionContainer = styled.div`
  position: ${(props) => props.isChatSelector ? 'relative' : 'absolute'};
  bottom: 0;
  right: 0;
  width: 100%;
  height: ${(props) => (props.small ? '1.9rem' : props.isChatSelector ? 'auto' : '4.75rem')};
  z-index: 1;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${(props) => props.isChatSelector ? designTokens.spacing.md : '0 1rem'};

  ${(props) => props.isChatSelector &&
    css`
      flex-direction: column;
      align-items: flex-start;
      gap: ${designTokens.spacing.xs};
    `}
`;

export const FileDescription = styled.div`
  margin-right: 0.75rem;
  width: 100%;
`;

export const FileName = styled.div`
  font-family: ${designTokens.fonts.heading};
  font-weight: 600;
  font-size: ${(props) => props.isChatSelector ? '0.85rem' : '0.625rem'};
  color: ${(props) => props.isChatSelector ? designTokens.colors.gray[900] : 'inherit'};
  opacity: ${(props) => props.isChatSelector ? 1 : 0.5};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileSize = styled.div`
  display: flex;
  font-family: ${designTokens.fonts.body};
  font-size: ${(props) => props.isChatSelector ? '0.8rem' : '0.625rem'};
  color: ${(props) => props.isChatSelector ? designTokens.colors.gray[500] : 'inherit'};
  opacity: ${(props) => props.isChatSelector ? 1 : 0.7};
`;

export const DeleteFileButton = styled.div`
  position: absolute;
  top: ${designTokens.spacing.sm};
  right: ${designTokens.spacing.sm};
  background-color: ${designTokens.colors.error[500]};
  width: 1.5rem;
  height: 1.5rem;
  color: white;
  text-align: center;
  border-radius: ${designTokens.radius.md};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.15s ease;
  z-index: 2;

  &:hover {
    background-color: ${designTokens.colors.error[600]};
    transform: scale(1.1);
  }
`;

export const FileDeleteIcon = styled(FontAwesomeIcon)`
  font-size: 0.9rem;
  cursor: pointer;
`;

export const ProgressContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4rem 0;
  flex-wrap: wrap;
  border-radius: ${designTokens.radius.lg};
`;

export const ProgressLabelContainer = styled.div`
  width: 80%;
  height: 10px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: ${designTokens.radius.full};
  display: flex;
`;

export const ProgressLabel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${designTokens.colors.success[500]};
  border-radius: ${designTokens.radius.full};
  height: 10px;
  width: ${(props) => props.progress && `${props.progress}%`};
  color: white;
  transition: width 0.3s ease;
`;

export const ProgressElement = styled.div`
  color: white;
  font-family: ${designTokens.fonts.heading};
  font-weight: 600;
  font-size: 10px;
  width: 100%;
  text-align: center;
`;

export const VideoCard = styled.div`
  width: 100%;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${designTokens.colors.gray[100]};
  border-radius: ${designTokens.radius.lg} ${designTokens.radius.lg} 0 0;
`;

export const VideoIcon = styled(FontAwesomeIcon)`
  font-size: 3rem;
  color: ${designTokens.colors.primary[500]};
  cursor: pointer;
`;

export const FileTypeImg = styled.img`
  position: absolute;
  ${(props) => props.small && css`width: 2rem;`}
  top: -2rem;
`;

export const FilePreviewContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${(props) => props.isChatSelector ? '140px' : '100%'};
  border-radius: ${(props) => props.isChatSelector ? `${designTokens.radius.lg} ${designTokens.radius.lg} 0 0` : '10px'};
  background: ${(props) => props.isChatSelector ? designTokens.colors.gray[100] : 'transparent'};
  overflow: hidden;

  ${(props) => !props.isClientSender &&
    css`
      width: initial;
      height: initial;
      justify-content: flex-start;
    `}
`;

export const FileDescriptionImage = styled.div`
  position: relative;
`;

export const FacebookAdDescription = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  padding: ${designTokens.spacing.md};
  gap: ${designTokens.spacing.sm};
`;

export const FacebookAdDescriptionTitle = styled.p`
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
`;

export const FacebookAdDescriptionLink = styled.a`
  font-size: 0.8rem;
  color: ${designTokens.colors.gray[500]};
  text-decoration: none;
  z-index: 10;
`;
